import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/concept";

export const getAllConcept = () => axios.get(API_PATH + "/get-all-concept");

export const pagingConcept = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getConceptById = (conceptId) => axios.get(API_PATH + "/" + conceptId);

export const getConceptByCode = (conceptId) => axios.get(API_PATH + "/get-by-code/" + conceptId);

export const saveConcept = concept => axios.post(API_PATH + '/saveOrUpdate', concept);

export const deleteConcept = conceptId => axios.delete(API_PATH + '/mark-delete/' + conceptId)

export const saveIngredientSyncStore = (searchObject) => axios.post(API_PATH + "/sync-ingredient-from-store", searchObject);

export const getListByConceptType = (conceptTypeCode) => axios.get(API_PATH + "/get-list-by-concept-type/" + conceptTypeCode);

export const downloadTemplate = () => {
    let url = API_PATH + "/download-template";
    return axios({
        url: url,
        method: "GET",
        responseType: "blob",
    });
}
export const downloadTemplateIndicator = () => {
    let url = API_PATH + "/download-template-indicator";
    return axios({
        url: url,
        method: "GET",
        responseType: "blob",
    });
}

export const pagingIndicator = (searchObject) => axios.post(API_PATH + "/search-by-page-indicator", searchObject);

export const saveIndicator = concept => axios.post(API_PATH + '/save-or-update-indicator', concept);